export default {
  registeredOrders (state) {
    return state.registeredOrders
  },
  loadingFeatured  (state) {
    return state.loadingFeatured
  },
  newOrders (state) {
    return state.registeredOrders.filter(elem => elem.status === 'A')
  },
  inProgressOrders (state) {
    return state.registeredOrders.filter(elem => elem.status === 'L')
  },
  finishedOrders (state) {
    return state.registeredOrders.filter(elem => elem.status === 'C')
  },
  canceledOrders (state) {
    return state.registeredOrders.filter(elem => elem.status === 'X')
  },
  orderDetailsModal (state) {
    return state.orderDetailsModal
  },
  selectedOrder (state) {
    return state.selectedOrder
  },
  loadingOrderActions (state) {
    return state.loadingOrderActions
  },
  searchOrders (state) {
    return state.searchOrders
  },
  currentPage (state) {
    return state.currentPage
  },
  totalPages (state) {
    return state.totalPages
  },
  totalItems (state) {
    return state.totalItems
  },
  itemsPerPage (state) {
    return state.itemsPerPage
  }

}



// WEBPACK FOOTER //
// ./src/store/pedido/getters.js